import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IExportRequest } from "interfaces/export-duck";
import { requestErrorHandler } from "utils";
import { ExportTransportsActions } from "store/ducks/transports";

export function* exportTransportsRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IExportRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/transports/list?${queryString}`);
    yield put(ExportTransportsActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ExportTransportsActions.failure(errorMessage));
  }
}